// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { CompanyGroup } from '@shared/models/company-group';
import { PlatformLookup } from '@shared/models/platform-lookup';
import { TenantName } from '@shared/models/tenant-name';
import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
    production: false,
    defaultApiBasePath: 'https://api.eightcap.com/stage',
    depositReportApiBasePath: 'https://espkz8ahz9.execute-api.ap-southeast-2.amazonaws.com/dev',
    application_key: '0e774374de7f4393aa859afd330d803f',
    application_id: 'EIG_ASIC-NEW_THAN2',
    session_expiry: 200000,
    supporterEmail: 'error-reports-administrator-portal@eightcap.com',
    entityOptions: [
        {
            code: TenantName.EIG_ASIC,
            name: 'Eightcap Pty Ltd'
        },
        {
            code: TenantName.EIG_CYSEC,
            name: 'Eightcap EU Ltd'
        },
        {
            code: TenantName.EIG_FCA,
            name: 'Eightcap Ltd UK'
        },
        {
            code: TenantName.EIG_SCB,
            name: 'Eightcap Global Ltd (SCB)'
        },
        {
            code: TenantName.EIG_SVG,
            name: 'Eightcap Global Ltd (SVG)'
        },
        {
            code: TenantName.EIG_VFSC,
            name: 'Eightcap Global Ltd'
        },
        {
            code: TenantName.BLU_ASIC,
            name: 'Blueberry Markets Group'
        },
        {
            code: TenantName.BLU_VFSC,
            name: 'Eightcap Global Ltd (Blueberry Markets)'
        },
        {
            code: TenantName.FCS_ASIC,
            name: 'FocusMarkets'
        },
        {
            code: TenantName.FCS_VFSC,
            name: 'FocusMarkets Global (FCS_VFSC)'
        },
        {
            code: TenantName.PAT_ASIC,
            name: 'Place A Trade Pty Ltd'
        },
        {
            code: TenantName.PAT_VFSC,
            name: 'Focus Markets LLC trading as Place a Trade'
        }
    ],
    platformLookups: [
        PlatformLookup.MT4L,
        PlatformLookup.MT4D,
        PlatformLookup.MT5L,
        PlatformLookup.MT5D,
        PlatformLookup.MT4ROWL,
        PlatformLookup.MT4ROWD,
        PlatformLookup.MT4_ROW2_L,
        PlatformLookup.MT4_ROW2_D,
        PlatformLookup.MT4CN2L,
        PlatformLookup.MT5L_FCS,
        PlatformLookup.MT5D_FCS,
        PlatformLookup.MT4_BBL,
        PlatformLookup.MT4_BBD,
        PlatformLookup.MT5_BBL,
        PlatformLookup.MT5_BBD,
        PlatformLookup.TV
    ],
    loginGroup: CompanyGroup.EIG
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
